export default function Badge({ children, colorClass }) {
  return (
    <span className={`px-2 py-0.5 rounded-full text-[9px] font-black uppercase tracking-wider border ${colorClass}`}>
      {children}
    </span>
  );
}
